var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "Fantahun Fekadu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fantahun Fekadu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff-mark",
    gradientUnits: "userSpaceOnUse",
    x1: 6,
    y1: 6,
    x2: 58,
    y2: 58
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5eead4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7dd3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818cf8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.50,25.94 Q63.00,32.00 59.50,38.06 L51.00,52.78 Q47.50,58.85 40.50,58.85        L23.50,58.85 Q16.50,58.85 13.00,52.78 L4.50,38.06 Q1.00,32.00 4.50,25.94        L13.00,11.22 Q16.50,5.15 23.50,5.15 L40.50,5.15 Q47.50,5.15 51.00,11.22 Z        M22.40,18.40 L41.60,18.40 L41.60,25.60 L29.60,25.60 L29.60,29.60        L38.40,29.60 L38.40,36.80 L29.60,36.80 L29.60,45.60 L22.40,45.60 Z",
    fill: "url(#ff-mark)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.73b09c4d35e3c7c98b09f0916721d5f3.svg";
export { ForwardRef as ReactComponent };